import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const STANDAREAMAINTENANCETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.StandAreaMaintenanceType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.StandAreaMaintenanceType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const STANDAREAMAINTENANCETYPE_CONFIG = {
  entityName: 'StandAreaMaintenanceType',
  localizationKey: 'Planning::Entity.StandAreaMaintenanceType',
  fields: STANDAREAMAINTENANCETYPE_FIELDS,
  permission: 'PlanningOperation.StandAreaMaintenanceTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
